import React from 'react'
import { 
  number, string, bool, oneOfType,
} from 'prop-types'

const radius = 30
const diameter = Math.PI * 2 * radius

const Progress = ({ progress = 0, showPercentage = false }) => {
  const pathDescription = `
    M 50,50 m 0,-${radius}
    a ${radius},${radius} 0 1 1 0,${2 * radius}
    a ${radius},${radius} 0 1 1 0,-${2 * radius}
  `
  const progressStyle = {
    stroke: '#00C853',
    strokeLinecap: 'round',
    strokeDasharray: `${diameter}px ${diameter}px`,
    strokeDashoffset: `-${((100 - progress) / 100 * diameter)}px`,
  }

  return (
    <div className="progress-circle">
      <svg
        viewBox="0 0 100 100"
        width={20}
        height={20}
      >
        <path
          d={pathDescription}
          strokeWidth={8}
          fillOpacity={0}
          style={{ stroke: 'rgba(235, 61, 61, 0.2)' }}
        />

        <path
          d={pathDescription}
          strokeWidth={8}
          fillOpacity={0}
          style={progressStyle}
        />
      </svg>

      {showPercentage && (
        <span className="progress-text">{progress}%</span>
      )}
    </div>
  )
}


Progress.propTypes = {
  progress: oneOfType([string, number]),
  showPercentage: bool,
}

export default Progress
